import * as yup from "yup";
import { PASSWORD_REGEX } from "src/constants/validate";
const schema = yup.object().shape({
  password: yup.string().matches(PASSWORD_REGEX, "Please enter a valid password"
  ).required("Password is required"),
  confirmPassword: yup.string().oneOf([yup.ref('password'), undefined], 'The passwords do not match').required("Password is required"),
});

export default schema;
